import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69baabd47d947e00146d8f90/svyatoshatalks/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download/69baabd47d947e00146d8f90/svyatoshatalks/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69baabd47d947e00146d8f90/svyatoshatalks/src/app/sign-up-login-screen/components/AuthForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69baabd47d947e00146d8f90/svyatoshatalks/src/components/ui/AppLogo.tsx");
